// src/components/AssistantScreen.js
import React, { useState, useEffect } from 'react';
import CustomChat from './CustomChat';
import StepProgress from './StepProgress';
import ApartmentList from './ApartmentList'; // Ensure this is ApartmentList
import { getListings } from '../services/listingService';

const RESULTAT_STEP_INDEX = 3;
const PROJET_STEP_INDEX = 0;

const AssistantScreen = ({ onShouldOpenFuturisticDetails, futuristicDetailsStepIndex, isFuturisticDetailsPanelOpen }) => {
  const [step, setStep] = useState(PROJET_STEP_INDEX);
  const [suggestedApartments, setSuggestedApartments] = useState([]);
  const [isLoadingListings, setIsLoadingListings] = useState(false);
  const [listingsError, setListingsError] = useState(null);

  const handleBackToChat = () => {
    setStep(PROJET_STEP_INDEX); // Go back to the first step (Projet)
    setSuggestedApartments([]); // Clear the suggested apartments
  };


  // ... (handleApartmentSelect and handleFetchListingsManually functions remain the same)
  const handleApartmentSelect = (apartmentData) => {
    console.log("Apartment data on select:", apartmentData);
    if (apartmentData && apartmentData.fullDetailsForPanel) {
      // Flatten apartmentData: combine top-level, fullDetailsForPanel, and additional_details
      const mergedApartmentData = {
        ...apartmentData,
        ...apartmentData.fullDetailsForPanel,
        ...(apartmentData.additional_details || {}), // Merge additional_details if it exists
      };

      onShouldOpenFuturisticDetails(mergedApartmentData);
      if (step !== futuristicDetailsStepIndex) {
        // setStep(futuristicDetailsStepIndex);
      }
    } else {
      console.error("Selected apartment data is missing fullDetailsForPanel:", apartmentData);
    }
  };

  const handleFetchListingsManually = async () => {
    
    setIsLoadingListings(true);
    setListingsError(null);
    try {
      const listings = await getListings();
      setSuggestedApartments(listings || []);
      if (!listings || listings.length === 0) {
        setListingsError("Aucune propriété trouvée pour le moment.");
      }
    } catch (error) {
      console.error("Failed to fetch listings manually:", error);
      setListingsError("Erreur lors du chargement des propriétés.");
      setSuggestedApartments([]);
    }
    setIsLoadingListings(false);
  };

  const showApartmentListView = suggestedApartments.length > 0 && (step === RESULTAT_STEP_INDEX );



  useEffect(() => {
    if (step < RESULTAT_STEP_INDEX && suggestedApartments.length > 0) {
      // setSuggestedApartments([]); // Optional: clear listings on navigating away
    }
  }, [step, suggestedApartments.length]);

  return (
    <div className="flex flex-col h-full w-full bg-background-light">
      <div className="flex flex-1 min-h-0"> {/* Main content row */}

        {/* Column 1: Chat or ApartmentList */}
        {/* Added min-w-0 to prevent overflow, changed overflow-y-auto to overflow-hidden */}
        <div className="flex-1 min-w-0 overflow-hidden bg-background-light">
          {showApartmentListView ? (
            <ApartmentList
              apartments={suggestedApartments}
              onSelectApartment={handleApartmentSelect}
              onBackToChat={handleBackToChat} // Pass the new handler
            />
          ) : (
            <CustomChat
              step={step}
              setStep={setStep}
              onShouldOpenFuturisticDetails={onShouldOpenFuturisticDetails}
              futuristicDetailsStepIndex={futuristicDetailsStepIndex}
              setSwipableApartments={setSuggestedApartments}
            />
          )}
        </div>

        {/* Column 2: Step Progress */}
        <StepProgress currentStep={step} />
      </div>

      {/* Manual Listings Trigger Area */}
      {!showApartmentListView && step === RESULTAT_STEP_INDEX && (
         <div className="p-4 bg-gray-200 border-t border-gray-300 text-center flex-shrink-0">
          {isLoadingListings && <p className="text-text-dark animate-pulse">Chargement des propriétés...</p>}
          {listingsError && <p className="text-red-600">{listingsError}</p>}
          {!isLoadingListings && !suggestedApartments.length && (
            <button
              onClick={handleFetchListingsManually}
              className="bg-accent-primary hover:bg-accent-hover text-white font-semibold py-2 px-4 rounded-lg transition duration-150 ease-in-out shadow-lg"
            >
              Afficher les propriétés suggérées
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default AssistantScreen;
